import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SubmissionService } from '../../services/submission/submissionsuccess.service';

@Injectable({
  providedIn: 'root',
})
export class SubmissionGuard implements CanActivate {
  constructor(
    private submissionService: SubmissionService,
    private router: Router
  ) {}

  canActivate(): boolean | Observable<boolean> {
    if (this.submissionService.isFormSubmitted()) {
      return true;
    } else {
      this.router.navigate(['/generate-invoice']);
      return false;
    }
  }
}
